import axios from "axios";
import { HTTP_API, makeRequest } from "../HttpClient";
import queryString from "query-string";

const API_BASE_URL = process.env.REACT_APP_BASE_URL
  ? process.env.REACT_APP_BASE_URL
  : "";

export default class TwoocaService {
  static async createUser(params) {
    var url = `${API_BASE_URL}/twooca/users/link`;
    return makeRequest(HTTP_API.POST, url, params);
  }

  static async checkCardTwooca() {
    const url = API_BASE_URL + "/twooca/users/check/card";
    return makeRequest(HTTP_API.GET, url);
  }

  static async getGochiKidUseDetail(gochiKidUseId) {
    const url = API_BASE_URL + "/twooca/receipt/" + gochiKidUseId;
    return makeRequest(HTTP_API.GET, url);
  }

  static async uploadGochiKidReceipt(gochiKidUseId, file, oldReceiptId) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("gochiKidUseId", gochiKidUseId);

    if (oldReceiptId) {
      formData.append("oldReceiptId", oldReceiptId);
    }

    const url = `${API_BASE_URL}/twooca/upload-receipt`;
    return axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static async submitGochiKidReceipt(params) {
    const url = `${API_BASE_URL}/twooca/submit-receipt`;
    return makeRequest(HTTP_API.POST, url, params);
  }
}
